import { CookieConsent } from '@makyoapp/makyo-tw-ui'

export const CookieConsentComponent = () => {
  return (
    <div className='fixed bottom-4 right-4 z-[99999]'>
      <CookieConsent accentColor='primary-20' onAcceptAll={() => {}} onAcceptNecessary={() => {}} />
    </div>
  )
}
